import { LAST_TIME_OPEN_CASE_ID } from './actionType';

export const updateLastOpenCaseId = (payload) => ({
    type: LAST_TIME_OPEN_CASE_ID,
    payload,
});
